export const DIAGNOSTIC_DROP_HISTORY_LIMIT = 500;
export type DiagnosticScope = { businessId: string; businessDeviceId: string };
export type DiagnosticDropReason =
  | 'rejected-batch'
  | 'delivery-unconfirmed'
  | 'server-discarded'
  | 'expired'
  | 'capacity'
  | 'invalid-entry'
  | 'destination-changed';
export type DiagnosticDropAlert = DiagnosticScope & {
  seq?: number;
  id: string;
  createdAt: string;
  reason: DiagnosticDropReason;
  count: number;
  attempts: number;
  httpStatus: number | null;
  errorCode: string | null;
  oldestAt: string | null;
  newestAt: string | null;
};
export type DiagnosticUploadBatch = DiagnosticScope & {
  id: string;
  baseURL: string;
  ids: string[];
  attempts: number;
  nextAttemptAt: number;
  createdAt: string;
  lastStatus: number | null;
  lastError: string | null;
  terminal?: { uploaded: number; alerts: DiagnosticDropAlert[]; receivedAt?: string };
};
export type DiagnosticDeliveryState = DiagnosticScope & {
  id: string;
  baseURL: string;
  cooldownUntil: number;
  nextFreshAt: number;
  lastSuccessAt: string | null;
  lastError: string | null;
};
/** One atomic local transaction; successful receipts and drops share finalization. */
export type DiagnosticDeliveryMutation = {
  batch?: DiagnosticUploadBatch;
  state?: DiagnosticDeliveryState;
  deleteBatchId?: string;
  deleteRecordIds?: string[];
  alerts?: DiagnosticDropAlert[];
  purgeOtherScopes?: DiagnosticScope;
};
